import React from "react";
import DataTable from "@/components/DataTable";
import KpiStrip from "@/components/KpiStrip";
import { ACTIVITY_MODULES } from "@/config/activities";

export default function ActivityModule({ module }) {
  const cfg = ACTIVITY_MODULES[module];
  return (
    <div className="space-y-6" data-testid={`activity-module-${module}`}>
      <KpiStrip module={module} />
      <DataTable
        title="Activity Log"
        endpoint="activities"
        columns={cfg.columns}
        defaults={{ module, role: cfg.role }}
        rowFilter={(r) => r.module === module}
      />
    </div>
  );
}
